import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SessionData, MemberMarginCurrency } from '../../../../core/session-data';
import { SessionService } from '../../../../core/session.service';

export interface SelectedSavingsResult {
  amount: number;
}

@Injectable({
  providedIn: 'root'
})
export class SavingsService {
  private savingsSelectedSubject: Subject<SelectedSavingsResult> = new Subject<SelectedSavingsResult>();
  private savingsRefreshSubject: Subject<any> = new Subject<any>();
  private savingsResetSubject: Subject<any> = new Subject<any>();
  private sessionData: SessionData;

  constructor(private sessionService: SessionService) {
    this.sessionData = this.sessionService.getSessionData();

  }

  public get onSavingsSelected(): Observable<SelectedSavingsResult> {
    return this.savingsSelectedSubject.asObservable();
  }

  public get onRefresh(): Observable<any> {
    return this.savingsRefreshSubject.asObservable();
  }

  public get onReset(): Observable<any> {
    return this.savingsResetSubject.asObservable();
  }

  public notifySavingsSelected(amount: number) {
    this.savingsSelectedSubject.next(<SelectedSavingsResult>{ amount: amount });
  }

  public refresh(changedCurrency: MemberMarginCurrency) {
    let acCurrency;
    if (this.sessionData && this.sessionData.memberInfo) {
      acCurrency = this.sessionData.memberInfo.updateMarginCurrencyWith(changedCurrency);
    }
    this.savingsRefreshSubject.next({ acCurrency: acCurrency });
  }

  public reset() {
    this.savingsResetSubject.next({});
  }
}
